import { Box, MenuItem } from "@mui/material";
import FranchiseLogo from "@/Layouts/components/FranchiseLogo";
import { ILocation } from "@/Common/interfaces/location";
import clsx from "clsx";
import { forwardRef } from "react";

interface ILocationMenuItemProps {
	location: ILocation;
	handleMenuClick: (selectedId: ILocation["locationId"]) => void;
	disabled?: boolean;
	selected: boolean;
}
export const LocationMenuItem = forwardRef<HTMLLIElement, Readonly<ILocationMenuItemProps>>(
	({ location, handleMenuClick, disabled, selected }, ref) => {
		return (
			<MenuItem
				onClick={() => {
					handleMenuClick(location.locationId);
				}}
				ref={ref}
				className={clsx("!block !w-full !font-sans !px-[16px] !py-[4px]", {
					"hover:bg-black/5 !text-default": !selected,
					"!bg-gray-highlight !text-white": selected,
				})}
				disabled={disabled}
			>
				<Box className={"flex flex-row justify-between !space-x-9 align-middle"}>
					<Box>{location.name}</Box>
					<Box className="flex !m-0 w-9 items-center justify-center">
						<FranchiseLogo logo={location.logo} isSelected={selected} className="max-w-9 h-5" />
					</Box>
				</Box>
			</MenuItem>
		);
	}
);
